export function show() {
  const waitMask = document.getElementById('js-global-wait-mask');
  waitMask.classList.add('js_active');

  const body = document.getElementById('js-body');
  body.setAttribute('aria-busy', 'true');
}

export function hide() {
  const waitMask = document.getElementById('js-global-wait-mask');
  waitMask.classList.remove('js_active');

  const body = document.getElementById('js-body');
  body.setAttribute('aria-busy', 'false');
}

// Expose the functions to the global scope for legacy scripts
// TODO remove this after migrating legacy scripts to modules
window.showLoadMask = show;
window.hideLoadMask = hide;